import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type AuthorizeGoogleUserMutationVariables = Types.Exact<{
   params: Types.AuthorizeGoogleUserParams
}>

export type AuthorizeGoogleUserMutation = {
   __typename?: 'Mutation'
   authorizeGoogleUser:
      | { __typename?: 'AuthorizeGoogleUserResult'; isAuthorized: boolean }
      | { __typename?: 'InvalidAuthorizationCode'; message?: string | null }
}

export const AuthorizeGoogleUserDocument = gql`
   mutation AuthorizeGoogleUser($params: AuthorizeGoogleUserParams!) {
      authorizeGoogleUser(params: $params) {
         ... on AuthorizeGoogleUserResult {
            isAuthorized
         }
         ... on InvalidAuthorizationCode {
            message
         }
      }
   }
`
export type AuthorizeGoogleUserMutationFn = Apollo.MutationFunction<
   AuthorizeGoogleUserMutation,
   AuthorizeGoogleUserMutationVariables
>
export type AuthorizeGoogleUserMutationResult = Apollo.MutationResult<
   AuthorizeGoogleUserMutation
>
export type AuthorizeGoogleUserMutationOptions = Apollo.BaseMutationOptions<
   AuthorizeGoogleUserMutation,
   AuthorizeGoogleUserMutationVariables
>
